module.exports = __webpack_public_path__ + "images/email/email-logo-2-4e80a34d70a1c4c15c5d2121075a8391.png";